module.exports = __webpack_public_path__ + "static/media/tap_01_img01.1019c798.png";